const color = {
  text: '#282835',
  cyan: '#1ee48f',
  lightCyan: '#40f3c2',
  purple: '#7335ff',
  strongPurple: '#741ee4',
  darkBlueGray: '#1c1c24',
  lightBlueGray: '#48485e',
  silver: '#98989f',
  darkSilver: '#858593',
  blueGray: '#ababdb',
  offWhite: '#e3e3e3',
  white: '#ffffff',
  black: '#000000',
}

const space = {
  half: '0.25rem', // one
  one: '0.5rem', // two
  two: '1rem', // three
  three: '2rem', // four
  four: '4rem', // five
  five: '8rem', // six
  six: '16rem', // seven
}

const borderRadii = {
  one: '0.125rem',
  two: '0.25rem',
  three: '0.5rem',
  four: '1rem',
  five: '2rem',
}

const fontWeight = {
  normal: 'normal',
  b: 'bold',
  one: 100,
  two: 200,
  three: 300,
  four: 400,
  five: 500,
  six: 600,
  seven: 700,
  eight: 800,
  nine: 900,
}

const fontSize = {
  /* Type Scale */

  one: '3rem',
  two: '2.25rem',
  three: '1.5rem',
  four: '1.25rem',
  five: '1rem',
  six: '0.875rem',

  // Small and hard to read for many people so use with extreme caution
  seven: '0.75rem',
  eight: '0.625rem',

  /*
   * For Hero/Marketing Titles
   *
   * These generally are too large for mobile
   * so be careful using them on smaller screens.
   * */

  headline: '6rem',
  subheadline: '5rem',
}

const breakpoint = {
  small: '40em',
  medium: '52em',
  large: '64em',
}

const myTheme = {
  color,
  space,
  borderRadii,
  fontWeight,
  fontSize,
  breakpoint,
}

export default myTheme



// WEBPACK FOOTER //
// ./src/styles/theme.js